import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Box, Center, Tabs } from "@mantine/core";

import { Button, Text, Title } from "components";
import { AuthorityConstants } from "constant";
import { CreditService } from "services";
import { displayClasses } from "styles";
import { CreditOptionsResponse, CreditResponse, UserResponse } from "types";
import { UserUtils } from "utils";

import CreditHeader from "./header";
import CreditRequest from "./request";
import CreditDocumentation from "./documentation";
import CreditPayment from "./payment";

const { ROLE_CR_C } = AuthorityConstants;

const TABS = {
  REQUEST: 'request',
  DOCUMENTATION: 'documentation',
  PAYMENT: 'payment'
}

interface ClientCreditProps {
  credit?: CreditResponse;
  options?: CreditOptionsResponse;
  user: UserResponse;
}

const ClientCredit = ({ credit, options, user }: ClientCreditProps) => {
  const { t } = useTranslation();

  const createNewCredit = useCallback(() => {
    CreditService.creditsNew(user.id);
  }, [user]);

  if (!credit || !options) {
    return (
      <Box>
        {UserUtils.hasAuthority(ROLE_CR_C) && <Button onClick={createNewCredit} mx={'sm'}>{t('credit.new.title')}</Button>}
        <Center>
          <Box my={64} w={450}>
            <Title order={4} ta={'center'}>{t('credit.view.empty.title')}</Title>
            <Text ta={'center'}>{t('credit.view.empty.description')}</Text>
          </Box>
        </Center>
      </Box>
    )
  }
  return (
    <Box>
      <CreditHeader credit={credit} />
      <Tabs defaultValue={TABS.REQUEST} keepMounted={false} variant={'pills'} mt={'lg'}>
        <Tabs.List>
          <Tabs.Tab value={TABS.REQUEST} className={displayClasses.tabList}>{t('credit.view.tab.' + TABS.REQUEST)}</Tabs.Tab>
          <Tabs.Tab value={TABS.DOCUMENTATION} disabled={!credit.requestedAt} className={displayClasses.tabList}>{t('credit.view.tab.' + TABS.DOCUMENTATION)}</Tabs.Tab>
          <Tabs.Tab value={TABS.PAYMENT} disabled={credit.status === 'DRAFT' || credit.status === 'PROCESSING'} className={displayClasses.tabList}>{t('credit.view.tab.' + TABS.PAYMENT)}</Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value={TABS.REQUEST} className={displayClasses.tabContent}><CreditRequest credit={credit} options={options} /></Tabs.Panel>
        <Tabs.Panel value={TABS.DOCUMENTATION} className={displayClasses.tabContent}><CreditDocumentation credit={credit} t={t} /></Tabs.Panel>
        <Tabs.Panel value={TABS.PAYMENT} className={displayClasses.tabContent}><CreditPayment options={options} credit={credit} t={t} /></Tabs.Panel>
      </Tabs>
    </Box>
  )

}

export default ClientCredit;